import axios from "axios";
import { DELETE_BUSINESS_ITEM, GET_ALL_BUSINESS, GET_ALL_BUSINESS_FAILED, GET_ALL_BUSINESS_SUCCESS, SINGLE_BUSINESS_ITEM, UPDATE_BUSINESS_ITEM } from "../../constants/businessConstant";
import ToastManager from "../../../modules/default/popup/alert/apiNotification";

export const GetAllBusiness = (data) => async (dispatch) => {
    dispatch({ type: GET_ALL_BUSINESS });
    try {
        const res = await axios.get(`/business`, { params: data });
        dispatch({
            type: GET_ALL_BUSINESS_SUCCESS,
            payload: {
                data: res.data.data,
                pagination: res.data.pagination,
                page: data.page
            }
        });
    } catch (error) {
        dispatch({ type: GET_ALL_BUSINESS_FAILED, payload: error.message });
    }
};
export const SingleBusinessData = (businessId) => async (dispatch, getState) => {
    
    const businessState = getState().businessAllData;
    const existingBusinessData = businessState.businessData; 
    const existingBusiness = Array.isArray(existingBusinessData.data) 
        ? existingBusinessData.data.find(business => business.id === businessId) 
        : null;

    if (existingBusiness === undefined) {
 
        try {
            const res = await axios.get(`/business?id=${businessId}`);
            dispatch({
                type: SINGLE_BUSINESS_ITEM,
                payload: res.data.data[0]
            });
        } catch (error) {
            dispatch({ type: GET_ALL_BUSINESS_FAILED, payload: error.message });
        }
    } else {

        dispatch({
            type: SINGLE_BUSINESS_ITEM,
            payload: existingBusiness
        });
    }
};

export const UpdateBusiness = (formData) => async (dispatch) => {
    const toastId = ToastManager.showLoading('Updating...');
    try {

        const response = await axios.put(`/business/min`, formData);
        console.log(response);
        if (response.status >= 200 && response.status < 300) {
            ToastManager.showSuccess(toastId, response.data.message || 'Business updated successfully!');
            dispatch({
                type: UPDATE_BUSINESS_ITEM,
                payload: {
                    data: response.data
                }
            });
            return response;
        }

    } catch (err) {
        let errorMsg = Object.values(Error.response.data).join(', ')
        ToastManager.showError(toastId, errorMsg || 'Failed to update business.');
    }
};

export const DeleteBusiness = (id) => async (dispatch) => {
    const toastId = ToastManager.showLoading('Deleting...');
    try {

        const response = await axios.delete(`/business/delete`, {
            data: { id: id }
        });
        if (response.status >= 200 && response.status < 300) {
            ToastManager.showSuccess(toastId, response.data.message || 'Business deleted successfully!');
            dispatch({
                type: DELETE_BUSINESS_ITEM,
                payload: {
                    id: id
                }
            });
        }

    } catch (err) {
        let errorMsg = Object.values(Error.response.data).join(', ')
        ToastManager.showError(toastId, errorMsg || 'Failed to delete business.');
    }
};